import React, {useState, useEffect, useRef, useMemo} from 'react';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container"
// import DatePicker from '@clayui/date-picker';
// import AssistanceCard from './AssistanceCard';
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete"
import QuadralDate from '@quadral/quadral-component-common/dist/components/date';
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField"
import QuadralTypography from "@quadral/quadral-component-common/dist/components/typography"
import QuadralButton from "@quadral/quadral-component-common/dist/components/button"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import QuadralTimeline from "@quadral/quadral-component-common/dist/components/timeline";
import { onlineProcessesService } from '../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPhone,
    faEnvelope,
    faCheck,
    faClipboard,
    faFileLines,
    faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import FormControlLabel from '@mui/material/FormControlLabel';

export default function Assistance({participationId, ...props}) {

    const [isFieldsFilled,setIsFieldsFilled] = useState(false);
    const [isDeviation, setIsDeviation] = useState(false);
    // const [ascending, setAscending] = useState('DESC');
    const [timeline, setTimeline] = useState([]);
    const [selected, setSelected] = useState("call");
    const [timeValue, setTimeValue] = useState(formatDateTime(new Date()));
    const [date, time] = formatDateTime(new Date()).split(" ");
    const [display, setDisplay] = useState('N1');
    const [deviation, setDeviation] = useState(0);
    const detailRef = useRef(null);
    const [formData, setFormData] = useState(() => {
        return{
            common: { date, time, escalationMotive: "Justificatif différent de l'attendu", detail: ""},
            call: { callReason: "selectmotive", callConclusion: "", escalationOrigin:""},
            escalation: { escalationStatus: (display === "N2") ? "Retours_a_analyser_interne" : "Retours_a_analyser_externe", subject: ""},
        };
    });
    const [activityRecordBody, setActivityRecordBody] = useState({
        participationId: participationId,
        subject: formData.call.callReason,
        description: formData.common.detail,
        callResult: formData.call.callConclusion,
        origin: formData.call.escalationOrigin
    });                    
    const [assistanceRecordBody, setAssistanceRecordBody] = useState({
        participationId: participationId,
        description: formData.common.detail,
        subject: formData.escalation.subject,
        origin: formData.common.escalationMotive,
        status: formData.escalation.escalationStatus,
    });
    const [updateAssistanceRecordBody, setUpdateAssistanceRecordBody] = useState({
        caseId: props.deviationId,
        comment: formData.common.detail,
        status: formData.escalation.escalationStatus,
    });
    // const motiveOptions = [
    //     {   label: "-- Sélectionner un motif --",    value: "selectmotive", },
	// 	{   label: "Global - Compréhension de l'enquête ou d'une relance",    value: "Global_Comprehension_de_l_enquete_ou_d_une_relance", },
	// 	{   label: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé",    value: "Global_Le_client_ne_dispose_pas_d_une_piece_que_nous_lui_avons_demande", },
    //     {   label: "Global - Souhait de confirmer bonne réception du dossier",    value: "Global_Souhait_de_confirmer_bonne_reception_du_dossier", },
    //     {   label: "Papier - Usage - Accompagnement renseignement formulaire",    value: "Papier_Usage_Accompagnement_renseignement_formulaire", },
    //     {   label: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)",    value: "Teledeclaration_Usage_Accompagnement_parcours_en_ligne", },
    //     {   label: "Télédéclaration - Usage - Souhait de réponse au format papier",      value: "Teledeclaration_Usage_Souhait_de_reponse_au_format_papier"     },
    //     {   label: "Télédéclaration - Usage - Téléchargement des pièces",      value: "Teledeclaration_Usage_Telechargement_des_pieces"     },
    //     {   label: "Télédéclaration - Problème technique",      value: "Teledeclaration_Probleme_technique"     },
    //     {   label: "Divers - Autres motifs",      value: "Divers_Autres_motifs"     },
    // ];
    const motiveOptions = useMemo(() => [
        {   label: "-- Sélectionner un motif --",    value: "selectmotive", },
		{   label: "Global - Compréhension de l'enquête ou d'une relance",    value: "Global - Compréhension de l'enquête ou d'une relance", },
		{   label: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé",    value: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé", },
        {   label: "Global - Souhait de confirmer bonne réception du dossier",    value: "Global - Souhait de confirmer bonne réception du dossier", },
        {   label: "Papier - Usage - Accompagnement renseignement formulaire",    value: "Papier - Usage - Accompagnement renseignement formulaire", },
        {   label: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)",    value: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)", },
        {   label: "Télédéclaration - Usage - Souhait de réponse au format papier",      value: "Télédéclaration - Usage - Souhait de réponse au format papier"     },
        {   label: "Télédéclaration - Usage - Téléchargement des pièces",      value: "Télédéclaration - Usage - Téléchargement des pièces"     },
        {   label: "Télédéclaration - Problème technique",      value: "Télédéclaration - Problème technique"     },
        {   label: "Divers - Autres motifs",      value: "Divers - Autres motifs"     },
    ], []);
    const statusOptions = [
        ...(!isDeviation ? [
            {   label: 'Escaladé interne',    value: 'Escalade_interne', },
		    {   label: 'Escaladé mandant',    value: 'Escalade_externe', },
        ] : []),
        ...(isDeviation ? [
            { label: 'Retours à analyser - interne', value: 'Retours_a_analyser_interne' },
            { label: 'Escaladé mandant', value: 'Escalade_externe' },
            { label: 'Traité', value: 'Traite' },
        ] : []),
    ];
    const statusOptionsAll = useMemo(() => [
        {   label: 'Escaladé interne',    value: 'Escalade_interne', },
		{   label: 'Escaladé mandant',    value: 'Escalade_externe', },
        {   label: 'Retours à analyser - interne',    value: 'Retours_a_analyser_interne', },
		{   label: 'Retours à analyser - mandant',    value: 'Retours_a_analyser_externe', },
        {   label: "Traité", value: "Traite" },
    ], []);
    const escalationOptions = [
        {   label: "Justificatif différent de l'attendu",    value: "Justificatif_different_de_l_attendu", },
        {   label: 'Inadéquation situation déclarée et justificatifs fournis',    value: "Inadequation_situation_declaree_et_justificatifs_fournis", },
        {   label: 'Situation complexe',    value: "Situation_complexe", },
        {   label: 'Autre',    value: "Autre", },
    ]

    // useEffect(() => handleChange(formatDateTime(new Date()), "date"), [props?.refreshTime]);
    useEffect(() => {
        if(display === "N1")setSelected("call");
        else if(display === "N3")setSelected("escalation");
    }, [display]);

    useEffect(() => {
        setIsDeviation(!!(props.deviationId));
    }, [props.deviationId])

    useEffect(() => {
        if(props.display.includes("survey-participation.deviation1")){
            setDisplay('N1');
        }
        if(props.display.includes("survey-participation.deviation2")){
            setDisplay('N2');
        }
        if(props.display.includes("survey-participation.deviation3")){
            setDisplay('N3');
        }
    }, [props.display])

    useEffect(() => {
        if(selected === "call"){
            setActivityRecordBody({
                participationId: participationId,
                subject: formData.call.callReason,
                description: `${props?.user} : ${formData.common.detail}`,
                callResult: !isDeviation ? formData.call.callConclusion : "Resolu",
                origin: formData.call.escalationOrigin
            });
            setIsFieldsFilled(!!(
                participationId && 
                (formData.call.callConclusion || isDeviation) && 
                formData.call.callReason && 
                formData.call.callReason!=="selectmotive" && 
                formData.common.detail.toString().trim() !== ""
            ));
        }else if(!isDeviation){
            setAssistanceRecordBody({
                participationId: participationId,
                description: formData.common.detail,
                subject: formData.escalation.subject,
                origin: formData.common.escalationMotive,
                status: formData.escalation.escalationStatus,
            });
            setIsFieldsFilled(!!(
                participationId &&
                // formData.escalation.escalationStatus && 
                formData.common.escalationMotive &&
                formData.common.detail.toString().trim() !== "" &&
                formData.escalation.subject.toString().trim() !== ""
            ));
        }else{
            setUpdateAssistanceRecordBody({
                caseId: props.deviationId,
                comment: formData.common.detail,
                status: formData.escalation.escalationStatus,
            });
            setIsFieldsFilled(!!(
                selected !== "call" &&
                formData.common.detail &&
                formData.common.detail.toString().trim() !== ""
            ));
        }
    },[formData, isDeviation, participationId, props.deviationId, props?.user, selected])


    useEffect(() => {
            const newTimeline = props?.assistanceRecords?.assistances?.map((element) => ({
                title: element.subject
                    ? (motiveOptions.find(opt => opt.value === element.subject)?.label || element.subject)
                    : "Non renseigné",
                content: 
                    <QuadralContainer orientation='column' sx={{gap: "0.5rem"}}>
                        {element.description}
                        <strong>{element.status ? (statusOptionsAll.find(opt => opt.value === element.status)?.label || element.status) : "inconnu"}</strong>
                    </QuadralContainer>,
                time: element.creationDate ? props.formatDate(element.creationDate.split("T")[0]) : "inconnu",
                icon: <FontAwesomeIcon icon={getTypeIcon(element.type)} />,
                iconColor: getTypeColor(element.type),
            }))
    
            setTimeline(newTimeline);
    }, [props?.assistanceRecords, motiveOptions, props.className, props.formatDate, statusOptionsAll, props]);

    function getTypeIcon(type) {
        switch (type) {
            case "Call":
                return faPhone;
            case "Email":
                return faEnvelope;
            case "Task":
                return faClipboard;
            case "logs":
                return faFileLines;
            case "Escalade":
                return faTriangleExclamation;
            default:
                return faCheck;
        }
    };

    function getTypeColor(type) {
        switch (type) {
            case "Call":
                return 'success';
            case "Email":
                return 'info';
            case "Task":
                return 'info';
            case "logs":
                return 'warning';
            case "Escalade":
                return 'warning';
            default:
                return 'secondary';
        }
    };
    
    function createToastError(msg) {
        props.quadralToast.error(msg, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    function setSelectedDetails(value) {
        setSelected(value);
        updateFormSection("call", "callConclusion", "");
    }

    function formatDateTime(date) {
        const twoNum = (n) => (n < 10 ? '0' + n : n);

        const day = twoNum(date.getDate());
        const month = twoNum(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours = twoNum(date.getHours());
        const minutes = twoNum(date.getMinutes());

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }
    
    function normalizeInputValue(value) {
        return value && value.target ? value.target.value : value;
    }

    function handleChange(newValue, field) {
        const normalizedValue = normalizeInputValue(newValue);
        switch (field){
            case "date" :
                let input = normalizedValue || "";
                const hasSeparators = /\/.*\/.* .*:/.test(input);
                if (!hasSeparators) {
                    input = input.replace(/\D/g, "");
                    if (input.length > 2) input = input.slice(0, 2) + "/" + input.slice(2);
                    if (input.length > 5) input = input.slice(0, 5) + "/" + input.slice(5);
                    if (input.length > 10) input = input.slice(0, 10) + " " + input.slice(10);
                    if (input.length > 13) input = input.slice(0, 13) + ":" + input.slice(13);
                }
                setTimeValue(input);
                const [datePart, timePart] = input.split(" ");
                updateFormSection("common", "date", datePart);
                updateFormSection("common", "time", timePart);
            break;
            
            case "subject":
            case "escalationStatus":
                updateFormSection("escalation", field, normalizedValue);
                break;

            case "callReason":
            case "callConclusion":
            case "escalationOrigin":
                updateFormSection("call", field, normalizedValue);
                break;

            default:
                updateFormSection("common", field, normalizedValue);
                break;
        }
    }

    function updateFormSection(section, field, newValue) {
        setFormData(formData => ({
            ...formData,
            [section]: {
            ...formData[section],
            [field]: newValue,
            },
        }));
    }

    function sendReport() {
        console.log(
                isFieldsFilled, 
                selected, 
                isDeviation, 
                participationId,
                formData.common.detail,
                formData.escalation.subject,
                formData.common.escalationMotive,
                formData.escalation.escalationStatus);
        if (!isFieldsFilled){
            createToastError("Veuillez compléter tous les champs obligatoires s'il vous plait");
            return;
        }else if (selected === "call") {
            return createActivity();
        }else{
            return isDeviation ? updateAssistance() : createAssistance();
        }
    }

    function createActivity(){
        props.showLoader();
        onlineProcessesService.createActivityRecord({participationId}, activityRecordBody)
            .then(dataReceived => {
                setActivityRecordBody(dataReceived);
                props.updateRecord();
                props.hideLoader();
                setDeviation(deviation+1);
                emptyFields();
            })
            .catch(err => {
                console.error(err);
                props.hideLoader();
        });
    }

    function createAssistance(){
        props.showLoader();
        onlineProcessesService.createAssistanceRecord({participationId}, assistanceRecordBody)
            .then(dataReceived => {
                setAssistanceRecordBody(dataReceived);
                props.updateRecord();
                props.hideLoader();
                emptyFields();
            })
            .catch(err => {
                console.error(err);
                props.hideLoader();
        });
    }

    function updateAssistance(){
        props.showLoader();
        onlineProcessesService.updateAssistanceRecord({participationId}, updateAssistanceRecordBody)
            .then(dataReceived => {
                setUpdateAssistanceRecordBody(dataReceived);
                props.updateRecord();
                props.hideLoader();
                emptyFields();
            })
            .catch(err => {
                console.error(err);
                props.hideLoader();
        });
    }

    function emptyFields(){
        handleChange("","callReason");
        handleChange("","detail");
        if(detailRef.current) detailRef.current.value = "";
    }

    return (
        <>
            <div style={{padding: '15px', minHeight: '60vh'}} className='container-fluid container-view'>

                <QuadralContainer orientation='row' sx={{borderRadius: '0px'}}>
                    <QuadralContainer orientation='column' className="supporting-doc-list order-2 order-md-1" col sm={12} md={6} style={{maxHeight:"53rem", overflow: "auto"}}>
                        <div style={{display: 'flex', gap: "1rem", alignItems: 'center', marginBottom: '1rem'}}>
                            <span>{props?.assistanceRecords?.totalCount} rapport{props?.assistanceRecords?.totalCount > 1 ? 's' : ''} trouvé{props?.assistanceRecords?.totalCount > 1 ? 's' : ''}</span>
                        </div>
                        <QuadralTimeline timeline={timeline}/>
                    </QuadralContainer>
                    {!(!isDeviation && (display === "N3")) && 
                    <QuadralContainer 
                        orientation='column' 
                        title={display === "N1" ? 'Tracer un appel' : 'Répondre à une escalade'} 
                        className="supporting-doc-list order-1 order-md-2"
                        sm={12} md={6}
                    >
                        {display === "N2" &&
                            <RadioGroup
                                name="controlled-radio-buttons-group"
                                value={selected}
                                onChange={(e, value) => setSelectedDetails(value)}
                            >
                                <FormControlLabel
                                    control={<Radio />}
                                    label="Tracer un appel"
                                    value="call"
                                />

                                <FormControlLabel
                                    control={<Radio />}
                                    label={isDeviation ? "Répondre à une escalade" : "Créer une escalade"}
                                    value="escalation"
                                />
                            </RadioGroup>
                        }
                        <QuadralContainer orientation='row'>
                            <QuadralContainer orientation='column' col sm={12} md={7}>
                                <QuadralDate 
                                    value={timeValue}
                                    disabled={true}
                                    placeholder="jj/mm/aaaa hh:mm"
                                    onChange={(value) => handleChange(value, "date")}
                                    label="Date et heure"
                                    noPadding  
                                />
                            </QuadralContainer>
                        </QuadralContainer>
                        {selected === "call" ? (
                        <>
                            <QuadralContainer orientation='column' col sm={12} md={12}>
                                <QuadralAutocomplete
                                    label="Sujet d'appel"
                                    value={motiveOptions.find(o => o.value === formData.call.callReason) ?? null}
                                    onChange={(event, option) => handleChange(option.value, "callReason")}
                                    aria-label="Select Label"
                                    id="callReasonField"
                                    options={motiveOptions}
                                    getOptionLabel={(option) => option.label}
                                    noPadding
                                />
                            </QuadralContainer>
                        </>
                        ) : !isDeviation ? (
                        <>
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' col sm={12} md={12}>
                                    <QuadralTextField 
                                        required
                                        id="standard-basic" 
                                        label="Sujet"
                                        onChange={(value) => handleChange(value, "subject")}
                                        noPadding
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                        </>
                        ) : null }
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' col sm={12} md={12}>
                                    <QuadralTextField 
                                        required
                                        label="Commentaire"
                                        id="standard-basic" 
                                        ref={detailRef}
                                        onChange={(value) => handleChange(value, "detail")} 
                                        style={{ minHeight:"3rem", maxHeight:"26rem" }}
                                        noPadding
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                        {(selected === "call" && !isDeviation)&& (
                        <>
                            <QuadralContainer>
                                <QuadralTypography variant='label'>Conclusion de l'appel</QuadralTypography>
                                <RadioGroup
                                    onChange={(event, value) => handleChange(value, "callConclusion")}
                                >
                                    <FormControlLabel control={<Radio/>} label="Situation résolue" value="Resolu"/>
                                    <FormControlLabel control={<Radio/>} label="Initier une escalade" value="Escalade"/>
                                </RadioGroup>
                            </QuadralContainer>
                            {(formData.call.callConclusion === "Escalade" &&
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' col sm={12} md={12}>
                                    <QuadralAutocomplete
                                        label="Motif d'escalade"
                                        value={escalationOptions.find(o => o.value === formData.call.escalationOrigin) ?? ""}
                                        onChange={(event, option) => handleChange(option.value, "escalationOrigin")}
                                        options={escalationOptions}
                                        getOptionLabel={(option) => option.label}
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                            )}
                        </>
                        )}
                        {(selected === "escalation" && display === "N2") && (
                        <>
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' col sm={12} md={12}>
                                    <QuadralAutocomplete
                                        label="Statut"
                                        value={statusOptions.find(o => o.value === formData.escalation.escalationStatus) ?? ""}
                                        onChange={(event, option) => handleChange(option.value, "escalationStatus")}
                                        options={statusOptions}
                                        getOptionLabel={(option) => option.label}
                                        noPadding
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                            {!isDeviation &&
                            <QuadralContainer orientation='row'>
                                <QuadralContainer orientation='column' col sm={12} md={12}>
                                    <QuadralAutocomplete
                                        label="Motif d'escalade"
                                        value={escalationOptions.find(o => o.value === formData.common.escalationMotive) ?? ""}
                                        onChange={(event, option) => handleChange(option.value, "escalationMotive")}
                                        options={escalationOptions}
                                        getOptionLabel={(option) => option.label}
                                    />
                                </QuadralContainer>
                            </QuadralContainer>
                            }
                        </>
                        )}
                        <QuadralContainer orientation='row'>
                            <QuadralContainer orientation='column' style={{textAlign: "end"}}>
                                {/* <button 
                                    style={{cursor: isFieldsFilled ? "pointer" : "default",}}
                                    className="btn confirmation"
                                    onClick={() => sendReport()}
                                >
                                    Enregistrer
                                </button> */}
                                <QuadralButton
                                    label='Enregistrer'
                                    onClick={() => sendReport()}
                                />
                            </QuadralContainer>
                        </QuadralContainer>
                    </QuadralContainer>
                    }
                </QuadralContainer>
            </div>
        </>
    );
}